import * as yup from "yup";

export const marginCallSchema = yup.object().shape({
  callDate: yup.object(),
  callRate: yup.number().positive().required(),
  transQuantity: yup.number().positive().required(),
  quantity: yup.number().positive().required(),
});
